// extracted by mini-css-extract-plugin
export var measureBox = "_redotech-arbiter-lib-common-text-measure-box-measure-box";